export default {
  AED: 3.996812,
  AFN: 96.695375,
  ALL: 116.014203,
  AMD: 429.314602,
  ANG: 1.956379,
  AOA: 547.532765,
  ARS: 200.860529,
  AUD: 1.532804,
  AWG: 1.958688,
  AZN: 1.849872,
  BAM: 1.953711,
  BBD: 2.17632,
  BDT: 115.71353,
  BGN: 1.952594,
  BHD: 0.410234,
  BIF: 2251.820504,
  BMD: 1.08816,
  BND: 1.432373,
  BOB: 7.500766,
  BRL: 5.593034,
  BSD: 1.08816,
  BTC: 0.000048033279,
  BTN: 88.641899,
  BWP: 13.898829,
  BYN: 2.739929,
  BZD: 2.188027,
  CAD: 1.454336,
  CDF: 2238.830211,
  CHF: 1.004821,
  CLF: 0.031606,
  CLP: 872.105885,
  CNH: 7.376996,
  CNY: 7.382078,
  COP: 4954.118517,
  CRC: 611.456907,
  CUC: 1.08816,
  CUP: 28.020122,
  CVE: 110.14557,
  CZK: 23.835494,
  DJF: 193.240423,
  DKK: 7.438934,
  DOP: 61.542275,
  DZD: 147.697638,
  EGP: 32.584301,
  ERN: 16.322401,
  ETB: 58.230052,
  EUR: 1,
  FJD: 2.343244,
  FKP: 0.883327,
  GBP: 0.883327,
  GEL: 2.878183,
  GGP: 0.883327,
  GHS: 13.460104,
  GIP: 0.883327,
  GMD: 67.193884,
  GNF: 9348.682564,
  GTQ: 8.52116,
  GYD: 229.041666,
  HKD: 8.523812,
  HNL: 26.778963,
  HRK: 7.535886,
  HTG: 161.7416,
  HUF: 389.299235,
  IDR: 16273.237446,
  ILS: 3.643088,
  IMP: 0.883327,
  INR: 88.739175,
  IQD: 1584.27504,
  IRR: 45893.150811,
  ISK: 156.69505,
  JEP: 0.883327,
  JMD: 167.345541,
  JOD: 0.772702,
  JPY: 141.50487915,
  KES: 135.203888,
  KGS: 93.636174,
  KHR: 4466.842367,
  KMF: 492.773722,
  KPW: 979.34406,
  KRW: 1342.034516,
  KWD: 0.332199,
  KYD: 0.904519,
  KZT: 501.12662,
  LAK: 18278.293673,
  LBP: 1641.514846,
  LKR: 395.11934,
  LRD: 170.297011,
  LSL: 18.745074,
  LYD: 5.1648,
  MAD: 11.012059,
  MDL: 20.494683,
  MGA: 4632.481419,
  MKD: 61.614436,
  MMK: 2279.535102,
  MNT: 3707.32355,
  MOP: 8.752909,
  MRU: 39.497179,
  MUR: 48.263149,
  MVR: 16.725021,
  MWK: 1114.189115,
  MXN: 20.441475,
  MYR: 4.637738,
  MZN: 69.533429,
  NAD: 18.738116,
  NGN: 493.894448,
  NIO: 39.664722,
  NOK: 10.747001,
  NPR: 141.826205,
  NZD: 1.676792,
  OMR: 0.418368,
  PAB: 1.08816,
  PEN: 4.205939,
  PGK: 3.825166,
  PHP: 59.387421,
  PKR: 251.291564,
  PLN: 4.708392,
  PYG: 8073.32192,
  QAR: 3.966399,
  RON: 4.910322,
  RSD: 117.389144,
  RUB: 74.890576,
  RWF: 1169.663609,
  SAR: 4.085282,
  SBD: 8.974859,
  SCR: 14.597757,
  SDG: 627.324278,
  SEK: 11.130062,
  SGD: 1.43148,
  SHP: 0.883327,
  SLL: 19222.347577,
  SOS: 617.130567,
  SRD: 35.13288,
  SSP: 141.74373,
  STD: 24836.155028,
  STN: 24.470992,
  SVC: 9.497702,
  SYP: 2734.034812,
  SZL: 18.745174,
  THB: 35.710693,
  TJS: 11.131831,
  TMT: 3.819442,
  TND: 3.364591,
  TOP: 2.516996,
  TRY: 20.467529,
  TTD: 7.369209,
  TWD: 32.927103,
  TZS: 2543.030076,
  UAH: 40.073349,
  UGX: 3989.159215,
  USD: 1.08816,
  UYU: 42.638061,
  UZS: 12234.211256,
  VES: 23.012335,
  VND: 25516.712423,
  VUV: 128.450767,
  WST: 2.935366,
  XAF: 655.957,
  XAG: 0.04613575,
  XAU: 0.00056392,
  XCD: 2.940807,
  XDR: 0.803928,
  XOF: 655.957,
  XPD: 0.0006288,
  XPF: 119.331742,
  XPT: 0.0010368,
  YER: 272.448006,
  ZAR: 18.72402,
  ZMW: 20.369313,
  ZWL: 350.387541,
};
